export default __webpack_public_path__ + "static/media/offeredposition.48308937.svg";